import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { CardMedia, Grid, IconButton } from "@material-ui/core";
import { useDispatch } from "react-redux";
import clsx from "clsx";
import svgIdioma from "../static/Íconos/arrow-right.svg";
import svgMenu from "../static/Íconos/X.svg";
import svgLogotipo from "../static/Identificador/Logo hotel.svg";

const useStyles = makeStyles((theme) => ({
    imageIconHeader: {
        width: "7%",
    },
    fontHeaderLang: {
        fontFamily: "Verdana",
        fontSize: 14,
    },
    selectLang: {
        color: "#FFFFFF",
        "& .MuiSvgIcon-root": {
            color: "#FFFFFF",
        },
        "& .MuiSelect-selectMenu": {
            paddingRight: 0,
            paddingLeft: 10,
        },
    },
    lineBar: {
        marginLeft: 5,
        marginTop: 5,
        marginRight: 5,
    },
    phoneBar: {
        marginLeft: 5,
        marginTop: 5,
        marginRight: 10,
        fontFamily: "Verdana",
        fontSize: 16,
    },
    lineaHR: {
        color: theme.palette.secondary.dark,
        width: "8vw",
        marginTop: 20,
        marginBottom: 20,
        borderStyle: "solid",
        border: "4px",
    },
}));

export default function HeaderRegister(props) {
    const classes = useStyles();
    const dispatch = useDispatch();

    //-------------------------------------------------------------------------------
    //----------------------------ESTADOS--------------------------------------------
    //-------------------------------------------------------------------------------
    const [namePage] = useState(props.namePage);
    let fontsizeText = window.screen.width < 600 ? "20px" : "30px";

    //-------------------------------------------------------------------------------
    //----------------------------FUNCIONES------------------------------------------
    //-------------------------------------------------------------------------------

    const handleClickBack = () => {
        dispatch({ type: "DRAWER_OPERATION_REGISTER", status: false });
        dispatch({ type: "DRAWER_OPERATION_LOGIN", status: true });
    };

    const handleClickClose = () => {
        dispatch({ type: "DRAWER_OPERATION_REGISTER", status: false });
    };

    //-------------------------------------------------------------------------------
    //--------------------------------VISTA------------------------------------------
    //-------------------------------------------------------------------------------

    return (
        <Grid container spacing={0} style={{ height: 300 }}>
            <Grid item xs={4} style={{ display: "flex", flexDirection: "column", alignItems: "start", marginTop: 40, paddingLeft: "5%" }}>
                <IconButton onClick={handleClickBack}>
                    <img alt="Idioma" src={svgIdioma} />
                </IconButton>
            </Grid>
            <Grid item xs={4} style={{ display: "flex", flexDirection: "column", alignItems: "center", marginTop: 20 }} className={clsx(classes.gridItem)}>
                <img alt="LogoHotel" src={svgLogotipo} />
            </Grid>
            <Grid item xs={4} style={{ display: "flex", flexDirection: "column", alignItems: "end", marginTop: 40, paddingRight: "5%" }} className={clsx(classes.gridItem)}>
                <IconButton aria-label="idioma" aria-controls="customized-menu" aria-haspopup="true" variant="contained" color="inherit" onClick={handleClickClose}>
                    <img alt="Menu" src={svgMenu} />
                </IconButton>
            </Grid>
            <Grid item xs={12} style={{ marginTop: "7%", display: "flex", flexDirection: "column", alignItems: "center", fontSize: fontsizeText, fontFamily: "Georgia Bold", color: "#A68A30", letterSpacing: 5 }}>
                {namePage}
                <hr className={classes.lineaHR} />
                <CardMedia component="img" image={require("../static/Íconos/Icon user.svg")} style={{ height: "80px", width: "80px" }} />
            </Grid>
        </Grid>
    );
}
